export const GlobalFilter = ({ filter, setFilter, debouncedResults }) => {

    const handleChange = (e) => {
        setFilter(e.target.value);
        debouncedResults(e);
    };

    return (
        <div className="customTable__searchFilter">
            <label>Search:</label>
            <input
                className="form-control"
                maxLength="40"
                type="text"
                value={filter || ""}
                onChange={handleChange}
            />
        </div>
    );
};